/**
 * Business logic per Orders With Requirement autocomplete
 * Ordini che richiedono requirement con timecard entries in un periodo
 * Pura - senza dipendenze da Vue
 */

import ordersService from '../services/ordersService';
import type { JobOrderAutocompleteResult } from '../models/jobOrder';
import type { ODataQueryBuilder } from './types';
import type { ODataContext } from '~/mixins/filterHandler/types';

export interface OrdersWithRequirementOptions {
	searchString?: string;
	id?: number | string | null;
	workerId: number | string;
	dateFrom: Date;
	dateTo: Date;
}

export async function getOrdersWithRequirementAutocomplete(
	buildQuery: ODataQueryBuilder,
	options: OrdersWithRequirementOptions,
): Promise<JobOrderAutocompleteResult[]> {
	const { searchString = '', id = null, workerId, dateFrom, dateTo } = options;

	const context: ODataContext = {
		select: 'id,code,name,isRequirementRequired',
		count: true,
		expand: {
			customer: {
				select: 'id,code,name',
			},
		},
		top: 20,
		orderBy: ['endDate desc', 'name'],
		filter: {
			and: [
				// Solo ordini che richiedono requirement
				{ isRequirementRequired: { eq: true } },
				// Che hanno timecard entries per questo worker nel periodo specificato
				{
					timecardEntries: {
						any: {
							workerId,
							date: {
								ge: dateFrom,
								le: dateTo,
							},
						},
					},
				},
			],
		},
	};

	if (searchString !== '') {
		context.filter!.and!.push({
			or: [
				{ 'tolower(code)': { contains: searchString } },
				{ 'tolower(name)': { contains: searchString } },
				{ 'tolower(customer/code)': { contains: searchString } },
				{ 'tolower(customer/name)': { contains: searchString } },
			],
		});
	} else if (id) {
		context.filter!.and!.push({ id: { eq: id } });
	}

	const result = await ordersService.getOrders(buildQuery(context));
	return result.value;
}
